import { render, staticRenderFns } from "./languageBar.vue?vue&type=template&id=ede4c9ba&scoped=true&lang=pug&"
import script from "./languageBar.vue?vue&type=script&lang=js&"
export * from "./languageBar.vue?vue&type=script&lang=js&"
import style0 from "./languageBar.vue?vue&type=style&index=0&id=ede4c9ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede4c9ba",
  null
  
)

export default component.exports